import React, { Component } from 'react'; 
import { Link } from 'react-router-dom'; 
 
class CertificatesContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: [],
      page_content: [],
      loading: 1,
      settings: {},
      showModal: false, // 👈 for popup
      selectedImage: null, // 👈 to store clicked image
    };
  }

  componentDidMount() {
    this.setState({ loading: 0 });
  }

  // 👇 Open popup
  handleImageClick = (image) => {
    this.setState({ showModal: true, selectedImage: image });
  };

  // 👇 Close popup
  closeModal = () => {
    this.setState({ showModal: false, selectedImage: null });
  };

  render() {

    const content = JSON.parse(localStorage.getItem("pagecontents"));
    const certificates = JSON.parse(localStorage.getItem("certificates"));

    if (this.state.loading === 1) {
      return <div>Loading...</div>;
    }

    return (
      <div>
        <section className="people-block section-padded">
          <div className="content">
           
           <div dangerouslySetInnerHTML={{ __html:  content[3].description }} />
          </div>
        </section>
        <section className="section-padded">
          <div className="content">
            <h1>BRAND FILES</h1>

            <div className="file-stack">
              <div data-aos="fade-up" data-aos-delay="1100" className="file aos-init aos-animate">
              {certificates.BRAND_FILES.map((item, index) => (

                 <Link
                  to={item.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="file-link"
                >
                  <div className="icon">
                    <img
                      src={item.image}
                      alt={item.title}
                    />
                  </div>
                  <div className="file-title">{item.title}</div>
                </Link>

                ))}
              </div>
            </div>
          </div>
        </section>

         <section className="section-padded">
          <div className="content">
            <h1>LICENSES & TRADEMARKS</h1>

            <div className="file-stack">
              
              {certificates.LICENSES_AND_TRADEMARKS.map((item, index) => (
<div data-aos="fade-up" data-aos-delay="1300" className="file aos-init aos-animate">
                 <Link
                  to={item.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="file-link"
                >
                  <div className="icon">
                    <img
                      src={item.image}
                      alt={item.title}
                    />
                  </div>
                  <div className="file-title">{item.title}</div>
                </Link>
</div>
                ))}
               
            </div>
          </div>
        </section>

         <section className="section-padded">
          <div className="content">
            <h1>CERTIFICATIONS</h1>

            <div className="file-stack">
             
              {certificates.CERTIFICATIONS.map((item, index) => (
 <div data-aos="fade-up" data-aos-delay="1100" className="file aos-init aos-animate">
                 <Link
                  to={item.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="file-link"
                >
                  <div className="icon">
                    <img
                      src={item.image}
                      alt={item.title}
                    />
                  </div>
                  <div className="file-title">{item.title}</div>
                </Link>
</div>
                ))}
              
            </div>
          </div>
        </section>
       
      </div>
    );
  }
}

export default CertificatesContent;
